import { PublicApiVendorEnum } from 'api/enums';
import lazyWithPreload from 'react-lazy-with-preload';

const PluginListPage = lazyWithPreload(() => import('./pages/plugin-list/Page'));
const PublicApiPage = lazyWithPreload(() => import('./pages/public-api/Page'));
const WhatsAppBotPage = lazyWithPreload(() => import('./pages/whatsapp-bot/Page'));
const ProcoreEmbeddedPage = lazyWithPreload(() => import('./pages/procore-embedded/Page'));
const GridwallListPage = lazyWithPreload(() => import('./pages/gridwall-list/Page'));
const GridwallDetailPage = lazyWithPreload(() => import('./pages/gridwall-detail/Page'));
const PlanGridPage = lazyWithPreload(() => import('./pages/plan-grid/Page'));
const GooglePage = lazyWithPreload(() => import('./pages/google-auth/Page'));
const MicrosoftSSOPage = lazyWithPreload(() => import('./pages/microsoft-sso-auth/Page'));
const AutodeskSSOPage = lazyWithPreload(() => import('./pages/autodesk-sso-auth/Page'));
const AconexPage = lazyWithPreload(() => import('./pages/aconix/Page'));
const PublicIngestionApiPage = lazyWithPreload(() => import('./pages/public-ingestion-api/Page'));
const TwoFactorAuthenticationPage = lazyWithPreload(() => import('./pages/two-factor-authentication/Page'));

const Routes = [
    {
        path: 'plugins',
        element: <PluginListPage />,
    },
    {
        path: 'plugins/:pluginId/whatsapp-bot',
        element: <WhatsAppBotPage />,
    },
    {
        path: 'plugins/:pluginId/public-api',
        element: <PublicApiPage />,
    },
    {
        path: 'plugins/:pluginId/procore',
        element: <ProcoreEmbeddedPage />,
    },
    {
        path: 'plugins/:pluginId/plangrid',
        element: <PlanGridPage />,
    },
    {
        path: 'plugins/:pluginId/google',
        element: <GooglePage />,
    },
    {
        path: 'plugins/:pluginId/microsoft',
        element: <MicrosoftSSOPage />,
    },
    {
        path: 'plugins/:pluginId/autodesk',
        element: <AutodeskSSOPage />,
    },
    {
        path: 'plugins/:pluginId/aconex',
        element: <AconexPage />,
    },
    {
        path: 'plugins/:pluginId/gridwall',
        element: <GridwallListPage />,
    },
    {
        path: 'plugins/:pluginId/gridwall/:gridwallId',
        element: <GridwallDetailPage />,
    },
    {
        path: 'plugins/:pluginId/photo-sentinel',
        element: <PublicIngestionApiPage vendor={PublicApiVendorEnum.PHOTO_SENTINEL} />,
    },
    {
        path: 'plugins/:pluginId/2fa',
        element: <TwoFactorAuthenticationPage />,
    },
];

export default Routes;
